import type { ControllerRenderProps } from 'react-hook-form'

import React from 'react'
import { Checkbox } from 'components'

interface IInputPostalCode {
  field: ControllerRenderProps
  className: string
}

export const InputIsSameAsCompany: React.FC<IInputPostalCode> = ({
  field,
  className,
}) => {
  return (
    <Checkbox
      variants='ternary'
      ref={field.ref}
      className={className}
      label='company:same.label'
      checked={field.value}
      onChange={field.onChange}
      name={field.name}
    />
  )
}
